var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.isPublicEventRoute ? 'div' : 'v-app',{tag:"component",class:{ 'tnm-public-app': _vm.isPublicEventRoute },attrs:{"id":"tnmt"}},[_c(_vm.isPublicEventRoute ? 'div' : 'v-main',{tag:"component"},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }